import {IDropdownData} from '../types/general.types';
import {Injectable} from '@angular/core';

@Injectable()
export class FormService {
    selectCompare(a: IDropdownData, b: IDropdownData): boolean {
        return a && b && a.id === b.id;
    }

    selectCompareWithSlug(a: IDropdownData, b: IDropdownData): boolean {
        return a && b && a.slug === b.slug;
    }

    isAdding(data: any) {
        return !data.id;
    }

    generateQueryStringObject(formData: object): object {
        for (const key in formData) {
            if (formData.hasOwnProperty(key) && !formData[key] && formData[key] !== 0) {
                delete (formData[key]);
            }
        }
        return formData || {};
    }
}
